import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

/**
 * Pushes a virtual page_view event to GTM's dataLayer on every SPA route
 * change so GA4 (and downstream tools like CallRail) always have an
 * up-to-date page_path / page_location associated with the session.
 *
 * The very first render is skipped because GTM's GA4 Configuration tag
 * already fires a page_view on initial document load.
 */
export const RouteChangeTracker = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Wait a tick so document.title (set by react-helmet-async) reflects the new page.
    const timeout = window.setTimeout(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "page_view_spa",
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 50);

    return () => window.clearTimeout(timeout);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteChangeTracker;
